import { BaseService } from "services/base-service";

import { API_ROUTES } from "constants/routes";

class SearchResultsService extends BaseService {
  constructor(url) {
    super(url);
    this.getSearchResult = this.getSearchResult.bind(this);
  }

  async getSearchResult(params) {
    try {
      const response = await this.agent.get("", params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }
}

const ServiceInstance = new SearchResultsService(API_ROUTES.searchResults);

export default ServiceInstance;
export { ServiceInstance as SearchResultsService };
